import { render, staticRenderFns } from "./indexXin.vue?vue&type=template&id=165e2278&scoped=true&"
import script from "./indexXin.vue?vue&type=script&lang=js&"
export * from "./indexXin.vue?vue&type=script&lang=js&"
import style0 from "./indexXin.vue?vue&type=style&index=0&id=165e2278&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e2278",
  null
  
)

export default component.exports